import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CartStoreRefiner } from '@common/refiners/cart.refiner';
import { BasketStoreRefiner } from '@common/refiners/basket.refiner';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { ProductStoreSelector } from '@common/selectors/product.selector';
import { CartService } from '@core/services/cart/cart.service';

import {
  KioskCartProductsListBlockDataSource,
  KioskCartProductsListBlockViewModel,
} from './kiosk-cart-products-list-block-view-model';

@Injectable()
export class KioskCartProductsListBlockStoreDataSource implements KioskCartProductsListBlockDataSource {
  private readonly cartService = inject(CartService);
  private readonly basketRefiner = inject(BasketStoreRefiner);
  private readonly cartRefiner = inject(CartStoreRefiner);
  private readonly productSelector = inject(ProductStoreSelector);
  private readonly marketplaceStoreSelector = inject(MarketplaceStoreSelector);

  readonly vm$: Observable<KioskCartProductsListBlockViewModel> = combineLatest({
    reconstructedCart: this.cartService.getCartLineItems$(),
    reconstructedShareOrderBasket: this.basketRefiner.selectCartItemsGroupedByUser,
    cartProducts: this.cartRefiner.selectActiveCartProducts,
    allProducts: this.productSelector.selectProducts$,
    currency: this.marketplaceStoreSelector.selectMarketplaceCurrency,
  }).pipe(
    map(
      ({
        reconstructedCart,
        reconstructedShareOrderBasket,
        cartProducts,
        allProducts,
        currency,
      }) => ({
        reconstructedCart,
        reconstructedShareOrderBasket,
        cartProducts,
        allProducts,
        currency,
      }),
    ),
  );
}
